<template>
  <o-view>
    <o-nav-bar title="Pechverhelping" :has-back-button="true" />
    <o-block-list title="Kies een product">
      <o-list-item
        icon="brands/vab"
        icon-style="logo"
        label="VAB Assistance (jaarlijks)"
      />
      <o-list-item
        icon="brands/vab"
        icon-style="logo"
        label="VAB Bike Assistance (jaarlijks)"
      />
      <o-list-item
        icon="brands/vab"
        icon-style="logo"
        label="VAB Assistance on demand"
      />
    </o-block-list>
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'

export default {
  name: 'Bike',
  components: {
    OMap
  },
  data() {
    return {
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: 'velo',
          title: 'Velo A',
          link: 'sales/bike/velo'
        },
        {
          coordinates: [3.723, 51.053],
          type: 'velo',
          title: 'Velo B',
          link: 'sales/bike/velo'
        },
        {
          coordinates: [3.72, 51.055],
          type: 'bluebike',
          title: 'Bluebike Gent',
          link: 'sales/bike/bluebike'
        }
      ]
    }
  }
}
</script>
